export const token = 'mpb-token-app-client-f76146fd-66ea-4487-bf7d-7b2b4f92cddc';
export const token_user = 'mpb-token-app-client-user-1b1e0812-99e4-4a5c-a4e5-2140d545b480';
